import * as Redux from "redux";

export const SELECT_PROCESSES = "SELECT_PROCESSES";
export function selectProcesses(processIds: number[]): ProcessSelectionAction {
    return {
        type: SELECT_PROCESSES,
        processIds: processIds
    };
}

export const DESELECT_PROCESSES = "DESELECT_PROCESSES";
export function deselectProcesses(processIds: number[]): ProcessSelectionAction {
    return {
        type: DESELECT_PROCESSES,
        processIds: processIds
    };
}

export const DESELECT_ALL_PROCESSES = "DESELECT_ALL_PROCESSES";
export function deselectAllProcesses(): Redux.Action {
    return {
        type: DESELECT_ALL_PROCESSES
    };
}

export interface ProcessSelectionAction extends Redux.Action {
    processIds: number[];
}
